import { cn } from '@/lib/utils';
import { Card } from '@/components/ui/Card';

interface SkeletonCardProps {
  rows?:      number;
  className?: string;
}

export function SkeletonCard({ rows = 3, className }: SkeletonCardProps) {
  return (
    <Card className={cn('p-5 space-y-3', className)}>
      {Array.from({ length: rows }, (_, i) => (
        <div
          key={i}
          className={cn(
            'h-4 rounded-md bg-zinc-800 animate-pulse',
            i === 0          ? 'w-2/3'
            : i === rows - 1 ? 'w-1/2'
            : 'w-full',
          )}
        />
      ))}
    </Card>
  );
}
